import styled from "styled-components";
import {
  MetricLabel,
  MetricSub,
  MetricValue,
  MotionMetricCard,
  PageActions,
  PageContainer,
  PageState as SharedPageState,
  PageTitle,
  PageTopBar,
  Section,
  SectionTitle,
  TableWrapper,
} from "../../styles/shared";

export const Wrapper = styled(PageContainer)``;

export const PageState = styled(SharedPageState)``;

export const TopBar = styled(PageTopBar)``;

export const Titulo = styled(PageTitle)``;

export const TopBarActions = styled(PageActions)``;

export const Secao = styled(Section)``;

export const SecaoTitulo = styled(SectionTitle)``;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(min(100%, 220px), 1fr));
  gap: 12px;
`;

export const CardWrapper = styled(MotionMetricCard)`
  position: relative;
  overflow: visible;
`;

export const CardLabel = styled(MetricLabel)``;

export const CardValor = styled(MetricValue)``;

export const CardSub = styled(MetricSub)``;

export const CardHint = styled.div`
  position: absolute;
  top: 12px;
  right: 12px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  border-radius: 999px;
  background: ${({ theme }) => theme.surfaceAlt};
  border: 1px solid ${({ theme }) => theme.border};
  color: ${({ theme }) => theme.textSecondary};
`;

export const CardTooltip = styled.div`
  position: absolute;
  left: 16px;
  right: 16px;
  bottom: calc(100% + 10px);
  padding: 10px 12px;
  border-radius: 12px;
  background: ${({ theme }) => theme.textPrimary};
  color: ${({ theme }) => theme.surface};
  font-size: 12px;
  line-height: 1.45;
  box-shadow: 0 16px 32px rgba(15, 15, 20, 0.2);
  opacity: 0;
  transform: translateY(6px);
  pointer-events: none;
  transition: opacity 0.16s ease, transform 0.16s ease;
  z-index: 8;

  ${CardWrapper}:hover &,
  ${CardWrapper}:focus-within & {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const TabelaTipoWrapper = styled(TableWrapper)``;

export const TabelaTipo = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
  min-width: 760px;
`;

export const Th = styled.th`
  /* Bugfix #13 (2026-05-29): sticky header amplo. */
  position: sticky;
  top: var(--app-header-height, 0px);
  z-index: 5;
  padding: 10px 14px;
  text-align: ${({ $center, $right }) =>
    $center ? "center" : $right ? "right" : "left"};
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: ${({ theme }) => theme.textSecondary};
  background: ${({ theme }) => theme.surfaceAlt};
  border-bottom: 1px solid ${({ theme }) => theme.border};
  white-space: nowrap;
`;

export const Tr = styled.tr`
  background: ${({ theme, $even }) => ($even ? theme.surface : theme.surfaceAlt)};

  &:hover {
    background: ${({ theme }) => theme.warningSurface};
  }
`;

export const Td = styled.td`
  padding: 10px 14px;
  text-align: ${({ $center, $right }) =>
    $center ? "center" : $right ? "right" : "left"};
  color: ${({ theme, $bold }) => ($bold ? theme.textPrimary : theme.textSecondary)};
  font-weight: ${({ $bold }) => ($bold ? 600 : 400)};
  border-bottom: 1px solid ${({ theme }) => theme.border};
  white-space: nowrap;
`;
